import {Component, ViewChild} from '@angular/core';
import {Alert, AlertController, Events, IonicPage, NavController, NavParams, Platform, Select} from 'ionic-angular';
import {TranslateService} from "@ngx-translate/core";
import {VizixService} from "../../providers/vizix.service";
import {Storage} from '@ionic/storage';
import {ConfigurationThing} from "../../models/configurationThing";
import {DeviceSelectPage} from "../device-select/device-select";
import {STORAGE_CONFIGURATION_THING, STORAGE_SET_UP_MODEL, STORAGE_SET_UP_MODEL_TEMP} from "../../app/app.constants";
import {ConfigurationService} from "../../providers/configuration.service";
import {AppConfigPage} from "../app-config/app-config";


@IonicPage()
@Component({
  selector: 'page-config',
  templateUrl: 'config.html',
})

export class ConfigPage {

  private tag = '[CONFIG]';

  language: string;
  configurations: ConfigurationThing[];
  selectedConfig: ConfigurationThing;
  alertSelectError: Alert;
  isAlert: boolean = false;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public translate: TranslateService,
              public events: Events,
              public _vizixService: VizixService,
              private _platform: Platform,
              private storage: Storage,
              private alertCtrl: AlertController,
              private configurationService: ConfigurationService) {

    this.configurations = navParams.get("configurations");
    this.selectedConfig = null;

    this.initAlerts();
  }

  ionViewDidLoad() {
    this.subscribeEvents();
    this.getLanguage();
  }

  initAlerts() {
    this.initAlertSelectError();
  }

  // Alert that shows when user clicks on Save Cycle Count button
  initAlertSelectError() {
    this.alertSelectError = this.alertCtrl.create({
      title: this.translate.instant('config.alerts.select_error.title'),
      message: this.translate.instant('config.alerts.select_error.message'),
      enableBackdropDismiss: false,
      buttons: [
        {
          text: this.translate.instant('config.alerts.select_error.ok'),
          handler: () => {

            this.isAlert = false;
            this.initAlertSelectError(); // We call this recursively because the alert is destroyed on dismiss

          }
        }
      ]
    });
  }


  @ViewChild('SelectConfig') SelectConfig: Select;
  @ViewChild('SelectLanguage') SelectLanguage: Select;

  goBack() {
    if (!this.isAlert) {
      this.SelectConfig.close();
      this.SelectLanguage.close();
      this.navCtrl.pop();
    }
  }

  ionViewWillEnter() {
    this._platform.registerBackButtonAction(() => {
      this.goBack();
    });
  }

  goToDeviceSelection() {
    if (this.selectedConfig != null) {

      let configurationError = this.configurationService.validateConfiguration(this.selectedConfig);
      if (configurationError == "") {
        //Fill default values for non-mandatory UDFs
        this.configurationService.fillDefaultValues(this.selectedConfig);
        this._vizixService.configurationApp = this.selectedConfig;

        this.storage.get(STORAGE_SET_UP_MODEL_TEMP).then((setupModel) => {
          console.log(this.tag, 'Storage Temp Setup Model', setupModel);
          this.storage.set(STORAGE_SET_UP_MODEL, setupModel).then(() => {
            console.log(this.tag, 'Setup Model Saved', setupModel);
            this.storage.remove(STORAGE_SET_UP_MODEL_TEMP);
          });
        });

        this.storage.set(STORAGE_CONFIGURATION_THING, this.selectedConfig);
        this.navCtrl.push(DeviceSelectPage, {'configurationThing': this.selectedConfig});
      } else {
        this.ShowAlertError(this.translate.instant('config.title'), configurationError);
      }
    }
    else {
      this.isAlert = true;
      this.alertSelectError.present();
    }
  }

  switchLanguage() {
    this.events.publish('language:changed', this.language);
  }

  subscribeEvents() {
    this.translate.onLangChange.subscribe(() => this.getLanguage());
  }

  getLanguage() {
    this.language = this.translate.currentLang;
  }


  ShowAlertError(title: string, messageText: string) {

    let alert = this.alertCtrl.create({
      title: title,
      message: messageText,
      buttons: [
        {
          text: this.translate.instant('config.buttons.ok'),
          role: 'cancel',
          handler: () => {
            this.isAlert = false;
          }
        }
      ]
    });
    this.isAlert = true;
    alert.present();
  }

  /**
   * Go to application config page
   */
  goToAppConfig() {
    this.navCtrl.push(AppConfigPage, {fromDeviceSelect: true});
  }
}



// WEBPACK FOOTER //
// ./src/pages/config/config.ts